import { ModelEntity, UtilsMisc, UtilsString } from '@pit/core';
import { JsonObject, JsonProperty } from 'json2typescript';
import { IDtoAddress } from '../interfaces/dto.address.interface';
import { IDtoAddressee } from '../interfaces/dto.addressee.interface';
import { DtoAddress } from './dto.address';

// @dynamic
@JsonObject('DtoAddressee')
export class DtoAddressee extends ModelEntity implements IDtoAddressee {

    constructor(initValues: Partial<IDtoAddressee> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('name1', String, true)
    public name1?: string = null;

    @JsonProperty('name2', String, true)
    public name2?: string = null;

    @JsonProperty('name3', String, true)
    public name3?: string = null;

    @JsonProperty('address', DtoAddress, true)
    public address?: IDtoAddress = null;

    public get fullAddress(): string {
        return ((UtilsMisc.isNullOrUndefined(this.address) === true) ? null : this.address.fullAddress);
    }

    public get fullName(): string {
        return UtilsString.stringFormat('{0} {1} {2}', this.name1, this.name2, this.name3).trim();
    }

}
